import React, { useState } from 'react';
import './SearchBar.css';

const SearchBar = ({ foodItems, onSelect }) => {
  const [query, setQuery] = useState('');

  const matches = foodItems.filter(item =>
    item.name.toLowerCase().includes(query.toLowerCase())
  );
  const handleSelect = (item) => {
  // Do something with selected item
  setQuery(''); // Clear input if desired
};


  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-input"
        placeholder="Search Ingredient..."
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      

      {query && (
        <div className="suggestions">
          {matches.map(item => (
  <div
    key={item.name}
    onClick={() => {
      onSelect(item);
      setQuery(item.name); // Update input with selected item
    }}
  >
    {item.name}
  </div>
))}

        </div>
      )}
    </div>
  );
};

export default SearchBar;
